export const getArrayItemById = (arr,id) => {
  let result = {}
  $.each(arr,function(i,v){
    if(v.id == id){
      result = v
    }
  })
  return result
}

export const getArrayItem = (arr,item) => {
  let result = {}
  $.each(arr,function(i,v){
    if(v==item){
      result = v
    }
  })
  return result
}



// WEBPACK FOOTER //
// ./src/utils/commonHelpers.js